var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"avp-contact-link",attrs:{"href":_vm.phoneLink}},[_vm._v(_vm._s(_vm.$t('generic.support.phone')))])
}
var staticRenderFns = []

export { render, staticRenderFns }